import React from 'react';
import HistoricalColorPicker from 'containers/HistoricalColorPicker';
import AnimationControlContainer from './AnimationControlContainer';
import { block } from './utils';

export interface AnimationColorSelectorProps {
  title: string;
  color: string;
  onChange: (color: string) => void;
}

const AnimationColorSelector: React.FC<AnimationColorSelectorProps> = ({
  title,
  color,
  onChange,
}) => {
  return (
    <AnimationControlContainer title={title}>
      <HistoricalColorPicker
        swatchClassName={block('animation-color-picker')}
        color={color}
        onChangeComplete={onChange}
      />
    </AnimationControlContainer>
  );
};

export default AnimationColorSelector;
